"use client";

import BreadcrumbsMetaHead from "component/meta-header/BreadcrumbsMetaHead";
import FAQMetaHead from "component/meta-header/FAQMetaHead";
import VideosMetaData from "component/meta-header/VideosMetaData";
import axios from "fetch-api/fetch-api";
import { CMS_PAGE_CSR_ONLY } from "modules/static-pages/static-page-constants";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { getPageDetails } from "util/url/apiConstants";
import { useState, useEffect } from "react";
import PageContainer from "../../modules/components/PageContainer";
import { deepFind } from "../../util/helper/deepFind";
import { isEmpty } from "../../util/lodash/isEmpty";
import ArticleMetaHead from "./ArticleMetaHead";
import styles from "./landingPage.module.scss";

const Sitemap = dynamic(() => import(/* webpackChunkName: "landing-sitemap" */ "component/landing-page/sitemap.component"));
const LandingPageAllBrands = dynamic(() => import(/* webpackChunkName: "landing-all-brands" */ "component/landing-page/LandingPageAllBrands"));
const LandingPageAllParts = dynamic(() => import(/* webpackChunkName: "landing-all-parts" */ "component/landing-page/LandingPageAllParts"));
const ArticleLandingPage = dynamic(() => import(/* webpackChunkName: "article-landing-page" */ "component/landing-page/ArticleLandingPage"));

function LandingPage(props: any) {
  const router = useRouter();
  const [clientData, setData] = useState();
  const { pageType } = props;

  useEffect(() => {
    const { pathname } = router.query;
    if (CMS_PAGE_CSR_ONLY.includes(pathname)) {
      // dispatch(showLoader());
      axios.get(`${getPageDetails}?url=${pathname}`).then((response: any) => {
        // dispatch(hideLoader());
        const landingPage = deepFind(response, "data.actualResponse.landingPage");
        if (landingPage) {
          setData(landingPage);
        } else {
          router.push("/[pathname]", "/404");
        }
      });
    } else {
      setData(undefined);
    }
  }, [pageType, router.asPath]);

  let content;

  const data = clientData || props.landingPage;

  if (!isEmpty(data)) {
    switch (data.type) {
    case "all-parts":
      // https://partsavatar.ca/best-selling-auto-parts

      content = <LandingPageAllParts data={data} />;
      break;
    case "all-brands":
      // https://partsavatar.ca/find-original-oem-auto-parts-oem-manufacturers-and-oem-suppliers

      content = <LandingPageAllBrands data={data} />;
      break;
    case "article":
      // https://partsavatar.ca/check-engine-light-scan-read-all-obd-2-trouble-codes-p0-powertrain-p1-p2-diagnose-repair-fix-engine-error
      content = <ArticleLandingPage data={data} />;
      break;
    case "sitemap":
      // https://partsavatar.ca/sitemap

      content = <Sitemap data={data} />;
      break;
    default:
      content = null;
      break;
    }
  }

  const {
    metaTitle = "", metaDescription = "", metaKeywords = "", url,
  } = data || {};
  let keywords = metaKeywords;
  if (Array.isArray(metaKeywords)) {
    keywords = metaKeywords.join(", ").toLowerCase();
  } else {
    keywords = metaKeywords.toLowerCase();
  }

  const metaProps = {
    title: metaTitle,
    description: metaDescription,
    keywords,
    image: props.landingPage?.bannerImages?.desktopImage,
    robots: "all",
    showOgTags: true,
  };
  return (
    <PageContainer className={styles.container} ShowGreyOuterContainer>

      <ArticleMetaHead
        metaProps={metaProps}
        url={data.url || url}
      />
      <BreadcrumbsMetaHead {...{ breadCrumbList: data.breadcrumbs }} />
      <FAQMetaHead contentIds={props.landingPage?.links?.contentIds || []} />
      <VideosMetaData videos={data?.videos} />
      {content}
    </PageContainer>
  );
}

export default LandingPage;
